<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Modifier un Produit</h4>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <div class="page-btn">
              <router-link to="/produits/" class="btn btn-secondary"
                ><vue-feather type="arrow-left" class="me-2"></vue-feather
                >Retourner vers les Produits</router-link
              >
            </div>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
      </div>
      <!-- /add -->
      <form @submit.prevent="submitForm">
        <div class="card">
          <div class="card-body add-product pb-0">
            <div class="accordion-card-one accordion" id="accordionExample">
              <div class="accordion-item">
                <div class="accordion-header" id="headingOne">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-controls="collapseOne"
                  >
                    <div class="addproduct-icon">
                      <h5>
                        <vue-feather type="info" class="add-info"></vue-feather
                        ><span>Informations du Produit</span>
                      </h5>
                      <a href="javascript:void(0);"
                        ><vue-feather
                          type="chevron-down"
                          class="chevron-down-add"
                        ></vue-feather
                      ></a>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="input-blocks add-product list">
                          <label>Référence</label>
                          <input
                            type="text"
                            class="form-control list"
                            v-model="form.referance_produit"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Nom de Produit</label>
                          <input
                            v-model="form.nom"
                            type="text"
                            class="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Catégorie</label>
                          <select
                            class="form-select"
                            v-model="form.categorie_produit_id"
                          >
                            <option value="">Choisir</option>
                            <option
                              v-for="cat in categoryOptions"
                              :key="cat.id"
                              :value="cat.id"
                            >
                              {{ cat.nom }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Dimension</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="form.dimensions"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Surface</label>
                          <input
                            type="Number"
                            min="0"
                            step="0.01"
                            class="form-control"
                            v-model="form.surface"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Volume</label>
                          <input
                            type="Number"
                            min="0"
                            step="0.01"
                            class="form-control"
                            v-model="form.volume"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div class="add-product-new">
                      <div class="row">
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="input-blocks add-product list">
                            <label>Poids</label>
                            <input
                              type="Number"
                              min="0"
                              step="0.01"
                              class="form-control list"
                              placeholder="Enter SKU"
                              v-model="form.poids"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Entrepot</label>
                            <vue-select
                              id="sellingtypess"
                              placeholder="Choose"
                              :options="warehouseData"
                              :reduce="
                                (option) => warehouseData.indexOf(option)
                              "
                              v-model="selectedWarehouse"
                            />
                          </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label"
                              >Statut d'achat {{ form.statut_achat }}</label
                            >
                            <div class="d-flex gap-3 mt-2">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_achat"
                                  id="achat_actif"
                                  :value="true"
                                  v-model="form.statut_achat"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="achat_actif"
                                >
                                  Actif
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_achat"
                                  id="achat_inactif"
                                  :value="false"
                                  v-model="form.statut_achat"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="achat_inactif"
                                >
                                  Inactif
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Statut de Vente</label>
                            <div class="d-flex gap-3 mt-2">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_vente"
                                  id="vente_actif"
                                  :value="true"
                                  v-model="form.statut_vente"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="vente_actif"
                                >
                                  Actif
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_vente"
                                  id="vente_inactif"
                                  :value="false"
                                  v-model="form.statut_vente"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="vente_inactif"
                                >
                                  Inactif
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Editor -->
                    <div class="col-lg-12">
                      <div
                        class="input-blocks summer-description-box transfer mb-3"
                      >
                        <label>Description</label>
                        <textarea
                          v-model="form.description"
                          class="form-control h-100"
                          rows="5"
                          required
                        ></textarea>
                        <p class="mt-1">Maximum 60 Characters</p>
                      </div>
                    </div>
                    <!-- /Editor -->
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-card-one accordion" id="accordionExample2">
              <div class="accordion-item">
                <div class="accordion-header" id="headingTwo">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-controls="collapseTwo"
                  >
                    <div class="text-editor add-list">
                      <div class="addproduct-icon list icon">
                        <h5>
                          <vue-feather
                            type="life-buoy"
                            class="add-info"
                          ></vue-feather
                          ><span>Prix & Stock</span>
                        </h5>
                        <a href="javascript:void(0);"
                          ><vue-feather
                            type="chevron-down"
                            class="chevron-down-add"
                          ></vue-feather
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample2"
                >
                  <div class="accordion-body">
                    <div class="tab-content" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div class="row">
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix d'achat</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_achat"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix de Vente</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_vente"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix de Vente Minimum</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_vente_minimum"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Taux TVA</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                value="20"
                                class="form-control"
                                v-model="form.taux_tva"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Stock Optimal</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                placeholder="Choose"
                                v-model="form.stock_optimal"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Seuil d'alerte de rupture de stock</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.seuil_alerte_stock"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          class="accordion-card-one accordion"
                          id="accordionExample3"
                        >
                          <div class="accordion-item">
                            <div class="accordion-header" id="headingThree">
                              <div
                                class="accordion-button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-controls="collapseThree"
                              >
                                <div class="addproduct-icon list">
                                  <h5>
                                    <vue-feather
                                      type="image"
                                      class="add-info"
                                    ></vue-feather
                                    ><span>Image</span>
                                  </h5>
                                  <a href="javascript:void(0);"
                                    ><vue-feather
                                      type="chevron-down"
                                      class="chevron-down-add"
                                    ></vue-feather
                                  ></a>
                                </div>
                              </div>
                            </div>
                            <div
                              id="collapseThree"
                              class="accordion-collapse collapse show"
                              aria-labelledby="headingThree"
                              data-bs-parent="#accordionExample3"
                            >
                              <div class="accordion-body">
                                <div class="text-editor add-list add">
                                  <div class="col-lg-12">
                                    <div class="add-choosen">
                                      <div class="input-blocks">
                                        <div class="image-upload">
                                          <input
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            ref="imageInput"
                                            @change="handleImageUpload"
                                          />
                                          <div class="image-uploads">
                                            <i
                                              data-feather="plus-circle"
                                              class="plus-down-add me-0"
                                            ></i>
                                            <h4>Ajouter des Images</h4>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="existing-images">
                                        <div
                                          class="phone-img"
                                          v-for="image in existingImages"
                                          :key="image.key"
                                          :class="{ removed: image.markedForRemoval }"
                                        >
                                          <img
                                            v-if="image.url"
                                            :src="image.url"
                                            alt="Image du produit"
                                          />
                                          <div v-else class="no-image-placeholder">
                                            <vue-feather
                                              type="image"
                                              class="text-muted"
                                            ></vue-feather>
                                          </div>
                                          <button
                                            type="button"
                                            class="remove-existing-btn btn btn-sm btn-danger"
                                            @click="toggleRemoveExisting(image)"
                                            :title="image.markedForRemoval ? 'Annuler la suppression' : 'Supprimer cette image'"
                                          >
                                            <vue-feather
                                              :type="image.markedForRemoval ? 'rotate-ccw' : 'trash-2'"
                                              size="14"
                                            ></vue-feather>
                                          </button>
                                        </div>
                                        <div
                                          v-if="!existingImages.length"
                                          class="no-image-text"
                                        >
                                          Aucune image enregistrée pour ce
                                          produit.
                                        </div>
                                      </div>

                                      <div
                                        class="new-image-previews"
                                        v-if="imagePreviews.length"
                                      >
                                        <div
                                          class="phone-img"
                                          v-for="(preview, idx) in imagePreviews"
                                          :key="preview.id"
                                        >
                                          <img
                                            :src="preview.url"
                                            alt="Nouvelle image"
                                          />
                                          <button
                                            type="button"
                                            class="remove-existing-btn btn btn-sm btn-danger"
                                            @click="removeNewImage(idx)"
                                            title="Retirer cette image"
                                          >
                                            <vue-feather type="x" size="14"></vue-feather>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="btn-addproduct mb-4">
            <button type="button" class="btn btn-cancel me-2">Annuler</button>
            <button type="submit" class="btn btn-submit">
              Modifier le Produit
            </button>
          </div>
        </div>
      </form>
      <!-- /add -->
    </div>
  </div>
  <add-product-modal></add-product-modal>
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
import Swal from "sweetalert2";
import { getWarehouseData, updateProduct } from "@/services/productsService";
import { fetchProductCategories } from "@/services/productCategoryService";
import { toast } from "vue3-toastify";
const warehouseData = [];
const warehouseIds = [];

export default {
  components: {},

  data() {
    return {
      form: {
        id: null,
        societe_id: null,
        entrepot_par_defaut: null,
        description: "",
        dimensions: "",
        prix_vente_minimum: "",
        nom: "",
        stock_optimal: null,
        image_produit: "",
        statut_achat: null,
        referance_produit: "",
        prix_achat: "",
        prix_vente: "",
        statut_vente: null,
        seuil_alerte_stock: null,
        surface: "",
        taux_tva: null,
        volume: "",
        poids: "",
        categorie_produit: "",
        categorie_produit_id: "",
      },
      categoryOptions: [],
      Distype: ["Choose", "Percentage", "Cash"],
      VariantChoose: ["Choose", "Color", "Red", "Black"],
      ChooseTypeDis: ["Choose", "Percentage", "Cash"],
      ExclusiveType: ["Exclusive", "Sales Tax"],
      ChooseCode: ["Choose", "Code34", "Code35", "Code36"],
      SellingType: ["Choose", "Transactional selling", "Solution selling"],
      ChooseAddNew: ["Choose", "Kg", "Pc"],
      ChooseAdd: ["Choose", "Nike", "Bolt"],
      SubSubCategory: ["Choose", "Fruits", "Computers", "Shoes"],
      SubCategory: ["Choose", "Lenovo", "Electronics"],
      ChooseNew: ["Choose", "Lenovo", "Electronics"],
      WarhouseStore: ["Choose", "Legendary", "Determined", "Sincere"],
      ThomasStore: ["Choose", "Thomas", "Rasmussen", "Fred john"],
      tags: ["red", "black"],
      salesStatus: ["Actif", "Inactif"],
      startdate: currentDate,
      startdateOne: currentDateOne,
      dateFormat: "dd-MM-yyyy",
      selectedWarehouse: "",
      warehouseData,
      warehouseIds,
      existingImages: [],
      selectedImages: [],
      imagePreviews: [],
      removeImageIds: [],
    };
  },
  methods: {
    async loadCategories() {
      try {
        const data = await fetchProductCategories();
        this.categoryOptions = (data || []).map((cat) => ({
          id: cat.id,
          nom: cat.nom,
        }));
        // Try to sync selection based on current product data
        if (!this.form.categorie_produit_id && this.form.categorie_produit) {
          const match = this.categoryOptions.find(
            (cat) => cat.nom === this.form.categorie_produit
          );
          if (match) {
            this.form.categorie_produit_id = match.id;
          }
        }
      } catch (error) {
        console.error(error);
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Impossible de charger les catégories."
        );
      }
    },
    getCategoryNameById(id) {
      const match = this.categoryOptions.find((cat) => String(cat.id) === String(id));
      return match ? match.nom : "";
    },
    resolveImageUrl(path) {
      if (!path) {
        return null;
      }
      if (/^https?:\/\//i.test(path)) {
        return path;
      }
      const base = (process.env.VUE_APP_URL || window.location.origin).replace(
        /\/$/,
        ""
      );
      const normalized = path.startsWith("storage/")
        ? path
        : `storage/${path}`.replace(/\/{2,}/g, "/");
      return `${base}/${normalized}`;
    },
    extractExistingImages(product) {
      if (!product) {
        return [];
      }
      const images = [];
      const register = (path, id = null, isPrimary = false) => {
        if (!path) {
          return;
        }
        const existing = images.find((img) => img.path === path);
        if (existing) {
          if (id && !existing.id) {
            existing.id = id;
            existing.key = `${id}-${path}`;
          }
          if (isPrimary) {
            existing.isPrimary = true;
          }
          return;
        }
        images.push({
          key: `${id || "primary"}-${path}`,
          id,
          path,
          isPrimary,
          url: this.resolveImageUrl(path),
          markedForRemoval: false,
        });
      };

      if (product.image_produit) {
        register(product.image_produit, null, true);
      }

      if (Array.isArray(product.images)) {
        product.images.forEach((img) => {
          const path = typeof img === "string" ? img : img?.path;
          const id = typeof img === "object" ? img?.id ?? null : null;
          register(path, id, false);
        });
      }

      return images;
    },
    createPreviewEntry(file) {
      return {
        id: `${file.name}-${file.lastModified}-${Math.random()
          .toString(36)
          .slice(2)}`,
        url: URL.createObjectURL(file),
      };
    },
    revokePreview(preview) {
      if (preview && preview.url) {
        URL.revokeObjectURL(preview.url);
      }
    },
    handleImageUpload(event) {
      const input = event.target;
      const files = input && input.files ? Array.from(input.files) : [];
      if (!files.length) {
        if (input) {
          input.value = "";
        }
        return;
      }

      files.forEach((file) => {
        const duplicate = this.selectedImages.some(
          (existing) =>
            existing.name === file.name &&
            existing.size === file.size &&
            existing.lastModified === file.lastModified
        );
        if (duplicate) {
          return;
        }
        this.selectedImages.push(file);
        this.imagePreviews.push(this.createPreviewEntry(file));
      });

      if (input) {
        input.value = "";
      }
    },
    removeNewImage(index) {
      const preview = this.imagePreviews[index];
      this.revokePreview(preview);
      this.imagePreviews.splice(index, 1);
      this.selectedImages.splice(index, 1);
    },
    clearNewImages() {
      this.imagePreviews.forEach((preview) => this.revokePreview(preview));
      this.imagePreviews = [];
      this.selectedImages = [];
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = "";
      }
    },
    toggleRemoveExisting(image) {
      if (!image) {
        return;
      }

      if (image.markedForRemoval) {
        image.markedForRemoval = false;
        if (image.id) {
          this.removeImageIds = this.removeImageIds.filter(
            (id) => id !== image.id
          );
        }
      } else {
        const remainingExisting = this.existingImages.filter(
          (img) => !img.markedForRemoval && img.key !== image.key
        ).length;
        const remainingTotal = remainingExisting + this.selectedImages.length;
        if (remainingTotal === 0) {
          toast.warning("Un produit doit conserver au moins une image.");
          return;
        }
        image.markedForRemoval = true;
        if (image.id && !this.removeImageIds.includes(image.id)) {
          this.removeImageIds.push(image.id);
        }
      }

    },
    applyProductData(product) {
      if (!product) {
        return;
      }
      this.form.id = product.id;
      this.form.societe_id = product.societe_id;
      this.form.entrepot_par_defaut = product.entrepot_par_defaut;
      this.form.categorie_produit = product.categorie_produit;
      this.form.categorie_produit_id =
        product.categorie_produit_id ||
        (product.categorie ? product.categorie.id : "") ||
        "";
      this.form.description = product.description;
      this.form.dimensions = product.dimensions;
      this.form.prix_vente_minimum = product.prix_vente_minimum;
      this.form.nom = product.nom;
      this.form.stock_optimal = product.stock_optimal;
      this.form.image_produit = product.image_produit;
      this.form.statut_achat =
        product.statut_achat === true || Number(product.statut_achat) === 1;
      this.form.referance_produit = product.referance_produit;
      this.form.prix_achat = product.prix_achat;
      this.form.prix_vente = product.prix_vente;
      this.form.statut_vente =
        product.statut_vente === true || Number(product.statut_vente) === 1;
      this.form.seuil_alerte_stock = product.seuil_alerte_stock;
      this.form.surface = product.surface;
      this.form.taux_tva = product.taux_tva;
      this.form.volume = product.volume;
      this.form.poids = product.poids;

      this.existingImages = this.extractExistingImages(product);
      this.removeImageIds = [];
      if (this.warehouseData.length) {
        this.selectedWarehouse = this.getWarehouseName(
          this.form.entrepot_par_defaut
        );
      }
    },
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    async getWarehouseData() {
      this.warehouseData = [];
      this.warehouseIds = [];
      if (localStorage.getItem("warehouses") != null) {
        const data = JSON.parse(localStorage.getItem("warehouses"));
        data.map((m) => {
          this.warehouseData.push(m.nom);
          this.warehouseIds.push(m.id);
        });
      } else {
        try {
          const data = await getWarehouseData();
          data.map((m) => {
            this.warehouseData.push(m.nom);
            this.warehouseIds.push(m.id);
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
      this.selectedWarehouse = this.getWarehouseName(
        this.form.entrepot_par_defaut
      );
    },
    getWarehouseID(option) {
      let index = this.warehouseData.indexOf(option);
      if (index != -1) {
        return this.warehouseIds[index];
      }
      return index;
    },
    getWarehouseName(option) {
      let index = this.warehouseIds.indexOf(option);
      if (index != -1) {
        return this.warehouseData[index];
      }
      return index;
    },

    async submitForm() {
      this.form.entrepot_par_defaut = this.getWarehouseID(
        this.selectedWarehouse
      );

      if (!this.form.categorie_produit_id) {
        toast.error("Choisissez une catégorie de produit.");
        return;
      }
      const selectedCategoryName = this.getCategoryNameById(
        this.form.categorie_produit_id
      );
      this.form.categorie_produit =
        selectedCategoryName || this.form.categorie_produit;

      if (
        this.existingImages.filter((img) => !img.markedForRemoval).length === 0 &&
        this.selectedImages.length === 0
      ) {
        toast.error("Ajoutez au moins une image avant d'enregistrer le produit.");
        return;
      }

      try {
        const formData = new FormData();
        formData.append("societe_id", this.form.societe_id);
        formData.append("nom", this.form.nom);
        formData.append("description", this.form.description ?? "");
        formData.append("dimensions", this.form.dimensions ?? "");
        formData.append(
          "categorie_produit_id",
          this.form.categorie_produit_id ?? ""
        );
        if (this.form.categorie_produit) {
          formData.append(
            "categorie_produit",
            this.form.categorie_produit ?? ""
          );
        }
        formData.append(
          "prix_vente_minimum",
          this.form.prix_vente_minimum ?? 0
        );
        formData.append("stock_optimal", this.form.stock_optimal ?? 0);
        formData.append("surface", this.form.surface ?? 0);
        formData.append("volume", this.form.volume ?? 0);
        formData.append("poids", this.form.poids ?? 0);
        formData.append("prix_achat", this.form.prix_achat ?? 0);
        formData.append("prix_vente", this.form.prix_vente ?? 0);
        formData.append(
          "referance_produit",
          this.form.referance_produit ?? ""
        );
        formData.append(
          "statut_achat",
          this.form.statut_achat ? 1 : 0
        );
        formData.append(
          "statut_vente",
          this.form.statut_vente ? 1 : 0
        );
        formData.append(
          "seuil_alerte_stock",
          this.form.seuil_alerte_stock ?? 0
        );
        formData.append("taux_tva", this.form.taux_tva ?? 0);
        if (
          this.form.entrepot_par_defaut !== "" &&
          this.form.entrepot_par_defaut !== null
        ) {
          formData.append(
            "entrepot_par_defaut",
            this.form.entrepot_par_defaut
          );
        }

        if (this.removeImageIds.length) {
          this.removeImageIds.forEach((id) =>
            formData.append("remove_image_ids[]", id)
          );
        }

        const removingPrimaryImages = this.existingImages.filter(
          (img) => img.isPrimary && img.markedForRemoval
        );
        const removingPrimary = removingPrimaryImages.length > 0;
        const removingPrimaryWithoutId = removingPrimaryImages.some(
          (img) => !img.id
        );

        if (
          removingPrimary &&
          (!this.selectedImages.length || removingPrimaryWithoutId)
        ) {
          formData.append("remove_primary_image", "1");
        }

        if (this.selectedImages.length) {
          this.selectedImages.forEach((file, index) => {
            if (index === 0) {
              formData.append("image_produit", file);
            } else {
              formData.append("images[]", file);
            }
          });
        }

        const response = await updateProduct(this.form.id, formData);
        const updatedProduct =
          response && response.data ? response.data : response;

        this.applyProductData(updatedProduct);
        this.clearNewImages();

        if (localStorage.getItem("products") != null) {
          let products = JSON.parse(localStorage.getItem("products"));
          products = products.map((product) => {
            if (product.id === updatedProduct.id) {
              return {
                ...product,
                nom: updatedProduct.nom,
                description: updatedProduct.description,
                dimensions: updatedProduct.dimensions,
                categorie_produit: updatedProduct.categorie_produit,
                prix_vente_minimum: updatedProduct.prix_vente_minimum,
                stock_optimal: updatedProduct.stock_optimal,
                surface: updatedProduct.surface,
                volume: updatedProduct.volume,
                poids: updatedProduct.poids,
                prix_achat: updatedProduct.prix_achat,
                prix_vente: updatedProduct.prix_vente,
                referance_produit: updatedProduct.referance_produit,
                image_produit: updatedProduct.image_produit,
                categorie_produit_id: updatedProduct.categorie_produit_id,
                statut_achat: updatedProduct.statut_achat,
                statut_vente: updatedProduct.statut_vente,
                seuil_alerte_stock: updatedProduct.seuil_alerte_stock,
                taux_tva: updatedProduct.taux_tva,
                entrepot_par_defaut: updatedProduct.entrepot_par_defaut,
                CreatedOn: product.CreatedOn,
                images: updatedProduct.images,
                primaryImagePath: updatedProduct.image_produit,
              };
            }
            return product;
          });
          localStorage.setItem("products", JSON.stringify(products));
        }

        if (localStorage.getItem("product") != null) {
          localStorage.setItem("product", JSON.stringify(updatedProduct));
        }

        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Produit modifié avec succès.",
          confirmButtonClass: "btn btn-success",
        }).then(() => {
          this.$router.push("/produits/");
        });
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Erreur lors de la modification du produit.";
        toast.error(message);
      }
    },
  },
  async mounted() {
    if (localStorage.getItem("product") != null) {
      let product = JSON.parse(localStorage.getItem("product"));
      this.applyProductData(product);
    }

    await this.loadCategories();
    await this.getWarehouseData();
  },
  beforeUnmount() {
    this.clearNewImages();
  },
};
</script>
<style scoped>
.existing-images {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}

.existing-images .phone-img {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #f6f8fb;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.existing-images .phone-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.existing-images .phone-img.removed {
  opacity: 0.45;
}

.existing-images .phone-img.removed::after {
  content: "Supprimée";
  position: absolute;
  bottom: 6px;
  right: 6px;
  font-size: 0.7rem;
  background: rgba(220, 53, 69, 0.85);
  color: #fff;
  padding: 2px 6px;
  border-radius: 6px;
}

.remove-existing-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.new-image-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.new-image-previews .phone-img {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #f6f8fb;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.new-image-previews .phone-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #b0b5bd;
}

.no-image-text {
  font-size: 0.9rem;
  color: #6c757d;
}
</style>
